module.exports = __webpack_public_path__ + "deb59f589cc54ae046b255e200decc0a.png";